import { FC } from 'react';
import cx from 'classnames';
import { HeaderCartEmptyMessageProps } from './types';
import styles from './HeaderCartEmptyMessage.module.scss';

export const HeaderCartEmptyMessage: FC<HeaderCartEmptyMessageProps> = ({
  message,
}) => {
  return (
    <div className={cx(styles['header__cart-empty-container'])}>
      <p
        className={cx(styles['header__cart-empty-text'], 'text-center')}
        data-testid="cat-header-cart-empty-message"
      >
        {message}
      </p>
    </div>
  );
};
